import React from 'react';
import { useTranslation } from 'react-i18next';
import ExistingTermsOfService from './ExistingTermsOfService';

const TermsOfServiceView = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50">
            <div className="prose prose-invert max-w-none text-gray-400">
                <ExistingTermsOfService />
            </div>
        </div>
    );
};

export default TermsOfServiceView;